import { newId } from '@petconsole/pure-base';
import { ImagePathKey } from '../types';
import ourImageExtension from './ourImageExtension';

const imagePathKey: ImagePathKey = (path, type, id, src) =>
  `${type}/${path}/${type}-${id}-${newId()}-${path}.${ourImageExtension({ src })}`;

export default imagePathKey;
